@if ((gtc$ | async); as gtc) {
  <section>
    <span [innerHtml]="gtc.data.attributes.text"></span>
  </section>
}
